import NCToast from '../NCToast';
import { bulkUpdateStage, updateItem } from 'services/newCritical';
import { getNextStage } from './FormUtil';

const getNormalizedJobNo = job => job?.jobNo || job?.jobno || '';

const getBulkJobLabel = jobs =>
  jobs
    .map(job => getNormalizedJobNo(job))
    .filter(Boolean)
    .join(', ');

const bulkSaveAndMove = async ({
  jobs,
  data,
  setLoading,
  updatePath,
  currentStageId,
  getDisabledStage,
  getCustomerType
}) => {
  if (!jobs?.length) return false;

  try {
    setLoading(true);

    const results = await Promise.all(
      jobs.map(async job => {
        const normalizedJob = {
          ...job,
          jobNo: getNormalizedJobNo(job)
        };

        const saveResult = await updateItem(
          {
            ...normalizedJob,
            ...data
          },
          updatePath
        );

        if (!saveResult) return false;

        const nextStage = await getNextStage(
          currentStageId,
          getDisabledStage?.(job),
          getCustomerType?.(job) ?? job?.customerType ?? 0
        );

        if (!nextStage?.id) return false;

        return {
          ...normalizedJob,
          stageId: nextStage.id
        };
      })
    );

    if (results.some(result => !result)) {
      NCToast(false);
      return false;
    }

    const success = await bulkUpdateStage({ jobs: results });
    NCToast(success);
    return success;
  } catch (error) {
    console.error('bulkSaveAndMove', error);
    NCToast(false);
    return false;
  } finally {
    setLoading(false);
  }
};

export { bulkSaveAndMove, getBulkJobLabel };
